module.exports = __webpack_public_path__ + "img/icon_autoExchange.0b7028fd.png";